import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=2b97b821&scoped=true"
import script from "./detailPage.vue?vue&type=script&lang=js"
export * from "./detailPage.vue?vue&type=script&lang=js"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=2b97b821&prod&lang=scss&scoped=true"
import style1 from "./detailPage.vue?vue&type=style&index=1&id=2b97b821&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97b821",
  null
  
)

export default component.exports